export var NSCropData;
(function (NSCropData) {
    NSCropData.CropSpecies = {
        Asparagopsis: {
            name: "Asparagopsis",
            scientific_name: "Asparagopsis armata",
        },
        BullKelp: { name: "Bull Kelp", scientific_name: "Nereocystis luetkeana" },
        Dulse: { name: "Dulse", scientific_name: "Palmaria spp." },
        Gracilaria: { name: "Gracilaria", scientific_name: "Gracilaria tikvahiae" },
        Nori: { name: "Nori", scientific_name: "Pyropia spp." },
        SkinnyKelp: {
            name: "Skinny Kelp",
            scientific_name: "Saccharina latissima forma angustissima",
        },
        SugarKelp: { name: "Sugar Kelp", scientific_name: "Saccharina latissima" },
        WingedKelp: { name: "Winged Kelp", scientific_name: "Alaria Marginata" },
        GiantKelp: { name: "Giant Kelp", scientific_name: "Macrocystis pyrifera" },
        Scallops: { name: "Scallops" },
        Clams: { name: "Clams" },
        Oysters: { name: "Oysters" },
        Mussels: { name: "Mussels" },
    };
})(NSCropData || (NSCropData = {}));
//# sourceMappingURL=cropData.js.map